import { Injectable } from '@angular/core';
import { PrePrintedLabel } from '../../../../core/model';
import { Occ } from '../../../../core/occ/occ-models';
import { Converter } from '../../../../core/util';

@Injectable({ providedIn: 'root' })
export class PrePrintedLabelNormalizer implements Converter<Occ.PrePrintedLabel, PrePrintedLabel> {
  convert(source: Occ.PrePrintedLabel, target?: PrePrintedLabel): PrePrintedLabel {
    if (source) {
      target = this.convertPrePrintedLabel(source);
    }

    return target;
  }

  private convertPrePrintedLabel(source: Occ.PrePrintedLabel): PrePrintedLabel {
    if (source) {
      const { ...target } = source;
      return {
        ...target,
      };
    } else {
      return undefined;
    }
  }
}
